module.exports = __webpack_public_path__ + "prod/1.42.2/img/fenxiao-two.f4d1de29.png";